import { z } from "zod/v4";

import { EmailTypeKey, EmailTypeValue } from "@/enums/preferences";

export interface UpdateEmailTypePayload {
  key: EmailTypeKey;
  value: EmailTypeValue[];
}

export const EmailTypeResponseSchema = z.object({
  created_at: z.string(),
  id: z.number(),
  key: z.enum(EmailTypeKey),
  updated_at: z.string(),
  value: z.array(z.enum(EmailTypeValue)),
});

export interface EmailType {
  name: string;
  id: EmailTypeValue;
}

export interface DraggableEvent {
  moved?: {
    element: EmailType;
    newIndex: number;
    oldIndex: number;
  };
}

export type EmailTypeResponse = z.infer<typeof EmailTypeResponseSchema>;
